import { create } from "zustand";

interface UserAvatarStore {
  isOpen: boolean;
  isEditing: boolean;
  openedFromProfileCard: boolean;
  openProfile: () => void;
  openProfileEdit: (fromProfileCard?: boolean) => void;
  closeProfile: () => void;
  setEditing: (editing: boolean) => void;
  resetProfileCardFlag: () => void;
}

const useUserAvatarStore = create<UserAvatarStore>((set) => ({
  isOpen: false,
  isEditing: false,
  openedFromProfileCard: false,
  openProfile: () => set({ isOpen: true, isEditing: false, openedFromProfileCard: false }),
  openProfileEdit: (fromProfileCard = false) => set({ isOpen: true, isEditing: true, openedFromProfileCard: fromProfileCard }),
  closeProfile: () => set({ isOpen: false, isEditing: false, openedFromProfileCard: false }),
  setEditing: (editing: boolean) => set({ isEditing: editing }),
  resetProfileCardFlag: () => set({ openedFromProfileCard: false }),
}));

export default useUserAvatarStore;
